import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface NoiseEffectProperties extends EffectProperties {
  opacity: number;
  premultiply: boolean;
}

// Create a reusable Noise component that can be used in both preview and world
const NoiseComponent = forwardRef<any, { properties: NoiseEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { opacity, premultiply } = properties;

  return (
    <PostProcessing.Noise
      ref={ref}
      opacity={opacity}
      premultiply={premultiply}
    />
  );
});

export const NoiseEffectItem: Effect<NoiseEffectProperties> = {
  id: '',
  name: 'Noise',
  type: 'effect',
  subtype: 'Noise',
  icon: 'Effect',
  properties: {
    opacity: 0.25,
    premultiply: false,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.opacity',
      type: 'number',
      label: 'Opacity',
      default: 0.25,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    },
    {
      key: 'properties.premultiply',
      type: 'boolean',
      label: 'Premultiply',
      default: false,
      panel: 'effect',
    }
  ],
  render: (properties: NoiseEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <NoiseComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};